import React, { useState } from "react";
import {
    Navbar,
    Nav,
    Container,
    Modal,
    Tabs,
    Tab,
    Dropdown
} from "react-bootstrap";
import userico from "../assets/panelImages/user/user.png";
import ManageAccount from "./SettingsHeader/ManageAccount";
import ChangePassword from "./SettingsHeader/ChangePassword";
import ProfileInfo from "./SettingsHeader/ProfileInfo";

function HeaderNavbar() {
    const [showSettings, setShowSettings] = useState(false);

    const handleOpenSettings = () => setShowSettings(true);
    const handleCloseSettings = () => setShowSettings(false);

    const handleLogout = () => {
        console.log("User logged out");
        // Add logout logic here
    };

    const handleProfileClick = () => {
        console.log("Navigate to Profile");
        // Navigate to profile or open profile modal
    };

    return (
        <>
            <Navbar expand="lg" className="header">
                <Container fluid>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto header-nav" role="navigation">
                             <Nav.Link aria-label="Notifications">
                                {/* Bell Icon */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 44.25 49.532">
                                    <path id="bell" className="header-icon" d="M3275.425,318.667h-15.844m15.844,0h13.2l-3.723-3.71a6.179,6.179,0,0,1-1.162-1.741,5.465,5.465,0,0,1-.4-2.054v-8.339a15.843,15.843,0,0,0-10.562-14.943v-.9a5.282,5.282,0,0,0-10.563,0v.9a15.854,15.854,0,0,0-10.562,14.943v8.342a5.367,5.367,0,0,1-1.558,3.792l-3.724,3.71h29.047Zm0,0v2.641a7.922,7.922,0,0,1-15.844,0v-2.641Z" transform="translate(-3245.378 -280.698)" fill="none" stroke="#8b8c8c" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                </svg>
                            </Nav.Link>

                            <Nav.Link  aria-label="Settings" onClick={handleOpenSettings}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 49.531 49.532">
                                    <g id="setting" transform="translate(-3411.738 -280.698)">
                                        <path id="Path_554" className="header-icon" data-name="Path 554" d="M3432.068,285.176a4.568,4.568,0,0,1,8.872,0,4.3,4.3,0,0,0,.951,1.888,4.631,4.631,0,0,0,1.716,1.246,4.531,4.531,0,0,0,2.087.333,4.617,4.617,0,0,0,2.033-.652,4.555,4.555,0,0,1,6.258,6.258,4.571,4.571,0,0,0-.661,2.017,4.617,4.617,0,0,0,1.585,3.809,4.472,4.472,0,0,0,1.875.966,4.549,4.549,0,0,1,0,8.846,4.472,4.472,0,0,0-1.875.966,4.617,4.617,0,0,0-1.585,3.811,4.571,4.571,0,0,0,.661,2.017,4.555,4.555,0,0,1-6.258,6.259,4.6,4.6,0,0,0-2.033-.651,4.531,4.531,0,0,0-2.087.333,4.637,4.637,0,0,0-1.716,1.244,4.3,4.3,0,0,0-.951,1.886,4.568,4.568,0,0,1-8.872,0,4.291,4.291,0,0,0-.952-1.888,4.636,4.636,0,0,0-1.716-1.246,4.523,4.523,0,0,0-2.086-.333,4.612,4.612,0,0,0-2.033.652,4.555,4.555,0,0,1-6.259-6.258,4.546,4.546,0,0,0,.661-2.017,4.375,4.375,0,0,0-.343-2.093,4.332,4.332,0,0,0-1.242-1.716,4.459,4.459,0,0,0-1.875-.966,4.549,4.549,0,0,1,0-8.846,4.459,4.459,0,0,0,1.875-.966,4.332,4.332,0,0,0,1.242-1.716,4.38,4.38,0,0,0,.343-2.094,4.546,4.546,0,0,0-.661-2.018,4.556,4.556,0,0,1,6.259-6.259A4.541,4.541,0,0,0,3432.068,285.176Z" fill="none" stroke="#8b8c8c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <path id="Path_555" className="header-icon" data-name="Path 555" d="M3444.426,305.464a7.93,7.93,0,1,1-2.324-5.6A7.955,7.955,0,0,1,3444.426,305.464Z" fill="none" stroke="#8b8c8c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                    </g>
                                </svg>
                            </Nav.Link>

                            {/* User Dropdown */}
                            <Dropdown align="end">
                                <Dropdown.Toggle
                                    as="div"
                                    className="d-inline-block userprofile"
                                    id="dropdown-user"
                                    style={{ cursor: "pointer" }}
                                >
                                    <Nav.Link aria-label="User Profile">
                                        <img src={userico} className="user" alt="User Icon" />
                                    </Nav.Link>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleProfileClick}>Profile</Dropdown.Item>
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Settings Modal */}
            <Modal show={showSettings} onHide={handleCloseSettings} className="settings" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Hi User!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs defaultActiveKey="profile" id="settings-tabs" className="mb-3">
                        <Tab eventKey="profile" title="Membership Info">
                            <ProfileInfo />
                        </Tab>
                        <Tab eventKey="account" title="Manage Account">
                            <ManageAccount />
                        </Tab>
                        <Tab eventKey="security" title="Update Password">
                            <ChangePassword />
                        </Tab>
                    </Tabs>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default HeaderNavbar;
